<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 300px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[1]" v-text="node.label.split('###')[0]"></span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 290px)">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>灌浆类型：</label>
                    <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <div class="searchGroup">
                    <label>孔号：</label>
                    <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>先导孔：</label>
                    <el-select v-model="search_Obj.f_is_pilot" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('yesNo')" :key="'pilot'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
            </div>
            <el-card ref="right_content" class="box-card">
                <div class="mainBody">
                    <div class="btnBox">
                        <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" v-if="grade==4"></Btns>
                        <Btns :menu_id="menu_id" :menus="main_btns" :ignore_ids="',3201,'" @on_btnclk="btnClick" v-else></Btns>
                    </div>
                    <div class="dataBox">
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column type="selection" align="center" width="50"></el-table-column>
                            <el-table-column prop="unit_name" label="单元工程" sortable="custom"></el-table-column>
                            <el-table-column prop="unit_code" label="单元编号" sortable="custom" width="150"></el-table-column>
                            <el-table-column prop="hole_code" label="孔号" sortable="custom"></el-table-column>
                            <el-table-column prop="hole_order" label="孔序" sortable="custom" width="120"></el-table-column>
                            <el-table-column prop="annex_count" label="附件" sortable="custom" width="80"></el-table-column>
                            <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                                <template slot-scope="scope">
                                    <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="order_index" label="顺序" sortable="custom" width="80"></el-table-column>
                            <el-table-column label="操作" width="330" align="center">
                                <template slot-scope="scope">
                                    <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox">
                        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            :pid="pid"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看灌浆孔"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
        <Import
            width="600px"
            title="导入灌浆孔"
            :isshow="importshow"
            @on-close="closeImportDialog"
            @on-imp-ok="impOk">
        </Import>
        <AnnexList
            width="600px"
            :data_id="model_id"
            :isshow="annexshow"
            @on-close="closeAnnexDialog">
        </AnnexList>
        <el-dialog
            title="删除确认"
            :visible.sync="deleteDialogVisible"
            width="600px">
            <p>确定要删除选中的灌浆孔吗？</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" @click="doDel(1)">仅删除无数据灌浆孔</el-button>
                <el-button type="danger" @click="doDel(2)">删除灌浆孔及报告数据</el-button>
                <el-button @click="cancelDel">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Import from "./import"
import AnnexList from "./annexlist"
import listutil from "@/libs/listutil"
import { getListData, delData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'

export default {
    name: 'workHoleList',
    mixins: [listutil],
    components: {Edit, Info, Import, Btns, LabBtns, AnnexList},
    data() {
        return {
            m_name: '灌浆孔',
            menu_id: 3200,
            list_url: "/api/admin/workhole/list",
            search_Obj: {
                f_grout_type: '',
                f_hole_code: '',
                f_is_pilot: '',
            },
            del_Obj:{
                url:'/api/admin/workhole/del',
                data:{
                    ids:'',
                    del_type: ''
                }
            },
            enu_name: ['grout_type', 'yesNo'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            importshow: false,
            annexshow: false,
            deleteDialogVisible: false,
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(2).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.current = 1
            this.getListData()
        },
        import(){
            this.importshow = true
        },
        impOk(){
            this.importshow = false
            this.getListData()
        },
        closeImportDialog(){
            this.importshow = false
        },
        annexSet(index, row){
            this.model_id = row.id
            this.annexshow = true
        },
        closeAnnexDialog(){
            this.annexshow = false
        },
        del(index, row) {
            this.del_Obj.data.ids = row.id
            this.deleteDialogVisible = true
        },
        delAll() {
            if (this.selectData.length <= 0) {
                this.$msg("请选择要删除的数据")
            } else {
                let ids = '';
                for (let data of this.selectData) {
                    if (ids === '') {
                        ids = data.id + "";
                    } else {
                        ids += "," + data.id;
                    }
                }
                this.del_Obj.data.ids = ids
                this.deleteDialogVisible = true
            }
        },
        doDel(type){
            this.del_Obj.data.del_type = type
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            delData(this.del_Obj).then(res => {
                loading.close()
                if (res.code == 1) {
                    this.deleteDialogVisible = false
                    this.$msgs(res.msg)
                    this.getListData();
                } else {
                    this.$msg(res.msg)
                }
            })
        },
        cancelDel(){
            this.deleteDialogVisible = false
            this.del_Obj.data.ids = ''
        },
    }
};
</script>